import { render, staticRenderFns } from "./AthleteMindsetReportCard.vue?vue&type=template&id=2b14af0c&scoped=true&"
import script from "./AthleteMindsetReportCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteMindsetReportCard.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteMindsetReportCard.vue?vue&type=style&index=0&id=2b14af0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14af0c",
  null
  
)

export default component.exports